<template>
  <v-card class="px-3 pt-4 pb-0" elevation="0" @click="handleClick">
    <div class="d-flex align-center" data-testid="challengeItem-container-main">
      <div
        class="entity-type-icon mr-2 d-flex justify-center rounded-circle"
        :class="ICON_COLORS_BY_ENTITY.challenge"
        data-testid="challengeItem-icon-challengeType"
      >
        <v-icon color="white" size="14">
          {{ ICONS_BY_ENTITY.challenge }}
        </v-icon>
      </div>
      <div class="ms-2">
        <p class="body2 blue-grey--text text--darken-3 mb-0">
          {{ challenge.name }}
        </p>
        <span class="caption blue-grey--text text--darken-1 mt-1">
          {{
            $t('home.activity_board.challenges.challenge_ends_at', {
              endDate: endsAt,
            })
          }}
        </span>
      </div>
    </div>
    <div v-if="challengeSites" class="mt-2 mb-0">
      <v-icon small color="blue-grey">
        mdi-warehouse
      </v-icon>
      <span class="ml-2 caption blue-grey--text">{{ challengeSites }}</span>
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { utils } from 'frontend-js-shared'

import mixin from '@/mixins/mixin.vue'

export default {
  name: 'ChallengeItem',

  mixins: [mixin],

  data() {
    return {
      ICONS_BY_ENTITY: this.$constants.ICONS_BY_ENTITY,
      ICON_COLORS_BY_ENTITY: this.$constants.ICON_COLORS_BY_ENTITY,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    endsAt() {
      return moment(this.challenge?.endAt?.slice?.(0, -1)).format(
        'MMM DD, YYYY'
      )
    },

    challengeSites() {
      const sites = this.challenge?.site?.map(siteItem => siteItem.name) ?? []

      if (_.isEmpty(sites)) return null

      const sitesText = sites.slice(0, 2).join(', ')

      if (sites.length <= 2) return sitesText

      return sitesText.concat(
        ' ',
        this.$t('common.plusOthersWithCount_other', {
          count: sites.length - 2,
        })
      )
    },
  },

  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },

  methods: {
    handleClick() {
      return this.navigateTo({
        name: 'challenge',
        params: {
          organizationId: this.organizationId,
          challengeId: utils.getEntityId(this.challenge),
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
div.entity-type-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
</style>
